import styled from 'styled-components';

export const ProjectsContainer = styled.div`
  margin-top: 2rem;
  z-index: 2;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;
  padding: 2rem 0;
`;

export const ProjectsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  position: relative;
  width: 100%;
  text-align: center;
`;

export const ProjectsTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 1rem 0 0;
  text-shadow: 0 4px 20px var(--accent-secondary-soft);
  letter-spacing: 0.05em;
  text-align: center;
`;

export const LeafIcon = styled.div`
  width: 32px;
  height: 32px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  filter: drop-shadow(var(--shadow-sm));
`;

export const ProjectsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 3rem 0;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  border: 1px solid var(--border-subtle);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoadingText = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: var(--text-heading);
  margin: 0;
  text-shadow: var(--shadow-sm);
  text-align: center;
`;

export const EmptyContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 3rem 0;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  border: 1px solid var(--border-subtle);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const EmptyText = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: var(--text-heading);
  margin: 0;
  text-shadow: var(--shadow-sm);
  text-align: center;
`;

export const ProjectButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CustomProjectButton = styled.button`
  padding: 0.8rem 1.5rem;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  background: var(--input-bg);
  color: var(--text-heading);
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  position: relative;
  overflow: hidden;
  min-width: 200px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--accent-secondary-soft), transparent);
    transition: left 0.5s ease;
  }

  &:hover {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 
      0 0 0 3px var(--accent-soft),
      var(--shadow-md);
    transform: translateY(-2px);
    color: var(--accent-secondary);
    
    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
  }

  &:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }
`;

// Container principal que segue o estilo do MainContainer
export const ProjectsSection = styled.section`
  width: 80%;
  max-width: 1200px;
  padding: 2rem;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  border: 1px solid var(--accent-secondary-soft);
  margin: 2rem auto;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent, var(--accent-secondary-soft), transparent);
    animation: shimmer 3s infinite;
    z-index: 1;
  }

  @keyframes shimmer {
    0% {
      transform: translateX(-100%) translateY(-100%) rotate(45deg);
    }
    100% {
      transform: translateX(100%) translateY(100%) rotate(45deg);
    }
  }

  @media (max-width: 768px) {
    width: 90%;
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    width: 95%;
    padding: 1rem;
  }
`;

// Componente de divisor
export const SectionDivider = styled.hr`
  width: 80%;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border-default), transparent);
  border: none;
  margin: 2rem auto;
  display: flex;
  justify-content: center;
`;

// Badge para contador de projetos
export const ProjectsBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  color: var(--app-bg);
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: 20px;
  margin-left: 1rem;
  box-shadow: var(--shadow-sm);
`;

// Container centralizado para o conteúdo principal
export const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

// Wrapper para centralizar todo o componente
export const ProjectsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 2rem 0;
`;